<template>
  <div v-if="donation" class="donation">
    <div class="donation__page container px-3 mt-3">
      <h1 class="donation__title">Your Donation is confirmed</h1>

      <Divider />
      <h5 class="donation__id text-center">
        Donation #: {{ donation.donationId }}
      </h5>
      <Divider />

      <div class="donation__item mb-3 mt-4">
        <div class="donation__item-preview mr-3">
          <img
            class="donation__item-preview-image"
            :src="getPreviewImage(product)"
          />
        </div>
        <div class="donation__item-details d-flex flex-column">
          <h4>{{ product.name }}</h4>
          <span class="mt-1">{{ donationTitle }}</span>
          <span class="donation__item-amount mt-1">{{
            formattedDonatedAmount
          }}</span>
        </div>
      </div>

      <Divider />

      <div class="terms-info mt-3 d-flex flex-column">
        <span class="terms-info__title mb-2">Production is not guaranteed</span>
        <p class="terms-info__description">
          This project will proceed if it reaches its goal by:
          {{ formattedClosingDate }}.
        </p>
        <p class="terms-info__description">
          If the project does not reach its publishing goal, you will be fully
          refunded the amount you pledge.
        </p>
        <p class="terms-info__description">
          For more information, see our
          <a href="/faq" target="_blank">FAQs</a> or our
          <a href="/terms" target="_blank">terms and conditions</a>.
        </p>
      </div>

      <Divider />

      <Button
        class="donation__back-button mb-5 mt-5"
        full-width
        variant="outline"
        @click="handleBackToStore"
      >
        Back to store
      </Button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import dayjs from 'dayjs';
import { fetchDonationBySid } from '../../../services/donations';

import Button from '~/components/Elements/Button';
import Divider from '~/components/Elements/Divider';

import { FallbackImageURL } from '@/misc/constants';
import formatMoney from '@/misc/formatMoney';

export default {
  name: 'SuccessDonationPage',

  components: {
    Button,
    Divider
  },

  data() {
    return {
      donation: null
    };
  },

  head: {
    title: 'Success donation | Found'
  },

  computed: {
    ...mapState('main', ['payoutCode']),
    ...mapGetters({
      currency: 'config/currency',
      region: 'config/region'
    }),
    product() {
      if (this.donation?.donationOption?.product) {
        return this.donation.donationOption.product;
      }

      return {};
    },
    formattedClosingDate() {
      return dayjs(this.donation?.funding?.closingDate || new Date()).format(
        'DD.MM.YY'
      );
    },
    donationTitle() {
      const title = this.$get(this.donation, 'donationOption.title');

      return title || 'Donate';
    },
    formattedDonatedAmount() {
      const transactionCurrency = this.$get(
        this.donation,
        'transactionCurrency',
        this.currency
      );

      const donationOptionPrice = (
        this.$get(this.donation, 'donationOption.prices') || []
      ).find((price) => price._id === this.donation.donationOptionPriceId);

      const price = donationOptionPrice || {
        amount: 0,
        region: this.region
      };

      return this.formatMoney(price.amount, transactionCurrency);
    }
  },

  mounted() {
    const sessionId = this.$route.query?.session_id;

    fetchDonationBySid(this.$axios, sessionId).then((donationInfo) => {
      this.donation = donationInfo;
    });
  },

  methods: {
    formatMoney,
    getPreviewImage(product) {
      if (product?.previewImages && product?.previewImages?.length) {
        return product?.previewImages[0]?.url;
      }
      return FallbackImageURL;
    },
    handleBackToStore() {
      this.$router.push({ path: '/' });
    }
  }
};
</script>

<style lang="scss" scoped>
.donation {
  &__item {
    display: flex;

    &-amount {
      font-size: 20px;
    }

    &-preview {
      position: relative;

      &-image {
        width: 110px;
        height: 110px;
        border-radius: 5px;
      }
    }

    &-details {
      font-size: 14px;
      font-weight: 500;
    }
  }

  &__title {
    font-size: 24px;
    font-weight: 700;
    text-align: center;
  }

  &__id {
    font-size: 20px;
  }

  &__back-button {
    text-transform: uppercase;
    font-weight: 600;
  }
}

.terms-info {
  &__title {
    font-size: 18px;
    font-weight: $font-weight-bold;
  }

  &__description {
    font-size: 14px;
    line-height: 18px;
  }

  a {
    color: inherit;
    text-decoration: underline;
  }
}
</style>
